import { useError } from 'react-use';

import { useRestQuery } from 'utils/hooks/api/useRestQuery';

const GET_ALLOWED_CUSTOM_EVENT_NAMES_URL = '/i/events/custom/allowed';

export const useDeprecatedAllowedCustomEvents = () => {
  const params = { addAllowedEvents: true };
  const onError = useError();
  const { data: customEvents, isLoading } = useRestQuery<string[]>(
    GET_ALLOWED_CUSTOM_EVENT_NAMES_URL,
    params,
    { onError },
  );
  return {
    customEvents,
    isLoading,
  };
};
